<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  min-height: 100%;
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

#app {
  min-height: 100vh;
  min-height: 100dvh;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  font-size: 14px;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* MessageBox 样式见 src/assets/element-overrides.css（在主题之后加载以保证覆盖） */

/* 苹果风格：全局弹框 (el-dialog) 基础 */
.el-dialog {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 1px rgba(0, 0, 0, 0.08) !important;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Microsoft YaHei', sans-serif !important;
}
.el-dialog__header {
  padding: 20px 24px 16px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.el-dialog__title { font-size: 18px; font-weight: 600; color: #1d1d1f !important; }
.el-dialog__headerbtn .el-dialog__close { color: #86868b; font-size: 18px; }
.el-dialog__body {
  padding: 20px 24px !important;
  max-height: 70vh;
  overflow-y: auto;
  font-size: 14px;
  color: #1d1d1f;
}
.el-dialog__footer {
  padding: 16px 24px 20px !important;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
.el-dialog__footer .el-button {
  border-radius: 10px !important;
  padding: 10px 20px !important;
  font-weight: 500;
}
.el-dialog__footer .el-button--default {
  border: 1px solid #d2d2d7; color: #1d1d1f; background: #fff;
}
.el-dialog__footer .el-button--default:hover {
  background: #f5f5f7; border-color: #d2d2d7; color: #1d1d1f;
}
.el-dialog__footer .el-button--primary { background: #0071e3 !important; border: none !important; }
.el-dialog__footer .el-button--primary:hover { background: #0077ed !important; }

/* 苹果风格：带表单的弹框 .dialog-apple；抽屉内滚动区加 .smart-hub-drawer-scroll.dialog-apple 复用同款 */
.dialog-apple .el-form-item__label,
.smart-hub-drawer-scroll.dialog-apple .el-form-item__label { font-weight: 500; color: #1d1d1f; }
.dialog-apple .el-input__inner,
.dialog-apple .el-textarea__inner,
.smart-hub-drawer-scroll.dialog-apple .el-input__inner,
.smart-hub-drawer-scroll.dialog-apple .el-textarea__inner {
  border-radius: 10px !important;
  border-color: #d2d2d7 !important;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.dialog-apple .el-input__inner:focus,
.dialog-apple .el-textarea__inner:focus,
.smart-hub-drawer-scroll.dialog-apple .el-input__inner:focus,
.smart-hub-drawer-scroll.dialog-apple .el-textarea__inner:focus {
  border-color: #0071e3 !important;
  box-shadow: 0 0 0 3px rgba(0, 113, 227, 0.2) !important;
}
.dialog-apple .el-select .el-input__inner,
.smart-hub-drawer-scroll.dialog-apple .el-select .el-input__inner { height: 40px; line-height: 40px; }
.dialog-apple .el-radio-group,
.smart-hub-drawer-scroll.dialog-apple .el-radio-group { display: flex; flex-wrap: wrap; gap: 8px; }
.dialog-apple .el-radio,
.smart-hub-drawer-scroll.dialog-apple .el-radio { margin-right: 0; }
.dialog-apple .el-radio__inner,
.smart-hub-drawer-scroll.dialog-apple .el-radio__inner { border-radius: 50%; border-color: #d2d2d7; }
.dialog-apple .el-radio__input.is-checked .el-radio__inner,
.smart-hub-drawer-scroll.dialog-apple .el-radio__input.is-checked .el-radio__inner { border-color: #0071e3; background: #0071e3; }
.dialog-apple .el-input-number,
.smart-hub-drawer-scroll.dialog-apple .el-input-number { border-radius: 10px; overflow: hidden; }
.dialog-apple .el-input-number .el-input__inner,
.smart-hub-drawer-scroll.dialog-apple .el-input-number .el-input__inner { border-radius: 10px; }
.dialog-apple .el-switch.is-checked .el-switch__core,
.smart-hub-drawer-scroll.dialog-apple .el-switch.is-checked .el-switch__core { border-color: #34C759; background-color: #34C759; }
.dialog-apple .field-tip,
.dialog-apple .form-tip,
.smart-hub-drawer-scroll.dialog-apple .field-tip,
.smart-hub-drawer-scroll.dialog-apple .form-tip { font-size: 12px; color: #86868b; margin-top: 6px; line-height: 1.4; }
.dialog-apple .el-divider__text,
.smart-hub-drawer-scroll.dialog-apple .el-divider__text { font-size: 12px; font-weight: 600; color: #86868b; }
.dialog-apple .el-collapse-item__header,
.smart-hub-drawer-scroll.dialog-apple .el-collapse-item__header { font-weight: 500; color: #1d1d1f; }
.dialog-apple .el-collapse-item__wrap,
.smart-hub-drawer-scroll.dialog-apple .el-collapse-item__wrap { border-bottom: none; }
.dialog-apple .el-collapse,
.smart-hub-drawer-scroll.dialog-apple .el-collapse { border: none; }
.dialog-apple .el-collapse-item,
.smart-hub-drawer-scroll.dialog-apple .el-collapse-item { margin-bottom: 8px; border: 1px solid rgba(0,0,0,0.06); border-radius: 10px; overflow: hidden; }
.dialog-apple .el-collapse-item__header,
.smart-hub-drawer-scroll.dialog-apple .el-collapse-item__header { border-bottom: 1px solid rgba(0,0,0,0.06); padding-left: 16px; height: 48px; }
</style>
